// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-card[data-v-03403b95] {\n    border-radius: 8px;\n}\n.text--disabled[data-v-03403b95] {\n    color: rgba(0, 0, 0, 0.38) !important;\n}\n", ""]);
// Exports
module.exports = exports;
